import React from 'react';
import { FadeIn } from './FadeIn';
interface ChapterBannerProps {
  src: string;
  alt: string;
  title: string;
}
export const ChapterBanner: React.FC<ChapterBannerProps> = ({
  src,
  alt,
  title
}) => {
  return <FadeIn data-id="element-83">
      <div className="w-full max-w-6xl mx-auto sm:px-6 mt-10 sm:mt-16 mb-6 sm:mb-10" data-id="element-84">
        <img src={src} alt={alt} className="w-full aspect-[16/9] object-cover sm:rounded-sm shadow-xl" data-id="element-85" />
      </div>
      <div className="max-w-[680px] mx-auto px-5 sm:px-6" data-id="element-86">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy font-serif leading-tight mb-6 sm:mb-8" data-id="element-87">
          {title}
        </h2>
      </div>
    </FadeIn>;
};